// 请求失败后的统一拦截，以及ajax的基本设置
import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';
import store from '../store'
// import { Toast } from '../plugins/vue-toast';

// function cleanRequest(req) {
//   for (const i in req) {
//     /* eslint guard-for-in: 0 */
//     if (req[i] !== 0 && !req[i]) {
//       delete req[i];
//     }
//   }
// }

axios.defaults.withCredentials = false;
axios.defaults.xsrfCookieName = null;
axios.defaults.headers['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept, Connection, User-Agent, Cookie';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const publicPath = {
  // dev:'http://106.75.84.4:9019',
  // dev:'http://106.75.84.4:9004',  //登录
  // dev: 'http://106.75.84.4:9023',  
  dev: 'https://qa.knowbox.cn:8004',
  test: 'https://qa.knowbox.cn:8004',
  // test: 'https://shark.heavi.cn:8762',
  //preview: 'http://devscience.knowbox.cn',
  preview: 'https://preshark.knowbox.cn:8044',
  production: 'https://stuapi.knowbox.cn',
};

const specialPath = {
  course_host_dev: 'https://qa.knowbox.cn',
  course_host_test: 'https://qa.knowbox.cn',
  course_host_preview: 'https://preshark.knowbox.cn:8044',
  course_host_production: 'https://stuapi.knowbox.cn'
}

axios.defaults.baseURL = publicPath[process.env.VUE_APP_INTER] || '/';
axios.defaults.timeout = 10000;
Vue.prototype.$http = axios;
Vue.http = axios;

// 请求拦截器
axios.interceptors.request.use(    
  config => {
  const { token } = store.state
  token && (config.headers.Authorization = token);        
  return config;   
},    
error => {        
  return Promise.error(error);    
})

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 404请求资源不存在
        case 404:
          // Toast({
          //   message: '网络请求资源不存在',
          //   delay: 1500
          // });
          break;
        // 其他错误，直接抛出错误提示
        default:
          // Toast({
          //   message: error.response.data.message,
          //   delay: 1500
          // });
      }
      return Promise.reject(error.response);
    }
  }
);

function handle(res, resolve, reject, isReturnOtherCode, isShowToast = true) {
  const code = res.data.code
  if (code === 99999) {
    resolve(res.data.data);
  } 
  // else if (code === 20003) {
  //   // 未登录的逻辑处理
  //   console.log(res.data)
  // } 
  else {
    isShowToast && 
    // Toast({
    //   message: res.data.msg,
    //   delay: 1500
    // })
    console.log(res.data)
    isReturnOtherCode && reject(res.data)
  }
}

// flag：是否关心除99999之外的状态码，关心 true，不关心 false
export function get(url, params = {}, flag = false, APIName) { 
  console.log('APIName', APIName); 
  const { version, token, source } = store.state
  if (APIName == 'course') {
    axios.defaults.baseURL = specialPath[APIName + '_host_' + process.env.VUE_APP_INTER] || '/';
  }else{
    axios.defaults.baseURL = publicPath[process.env.VUE_APP_INTER] || '/';    
  }
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: Object.assign({ version, source, token },params)
    }).then(res => {
      handle(res, resolve, reject, flag)
    }).catch(err => {
      console.warn(err.data)
      // reject(err.data)
    })
  });
}

export function post(url, params ={}, flag = false, APIName, isShowToast = true) {
  console.log('APIName', APIName); 
  const { version, token, source } = store.state
  if (APIName == 'course') {
    axios.defaults.baseURL = specialPath[APIName + '_host_' + process.env.VUE_APP_INTER] || '/';
  }else{
    axios.defaults.baseURL = publicPath[process.env.VUE_APP_INTER] || '/';    
  }
  return new Promise((resolve, reject) => {
       axios.post(url, qs.stringify(Object.assign({ version, source, token },params )))
      .then(res => {
        handle(res, resolve, reject, flag, isShowToast)
      }).catch(err =>{
        console.warn(err.data)
        // reject(err.data)
      })
  });
}

// 下面一行代码可以删了
export default axios;
